/**
 * Stripe.js detection for the Radar session mint (PAY-2001).
 *
 * PaymentKit.js never adds Stripe.js to the page. The merchant loads it with their
 * own `<script src="https://js.stripe.com/v3/">` tag, and this module only tells
 * whether that tag or `window.Stripe` is there.
 */

import { isCoreStripeJsUrl } from "./radar-session-decisions";

export function isStripeJsAvailable(): boolean {
  return typeof window !== "undefined" && "Stripe" in window;
}

function isPageStripeJsTagPresent(): boolean {
  if (typeof document === "undefined") return false;
  const candidates = document.querySelectorAll<HTMLScriptElement>('script[src*="js.stripe.com"]');
  return Array.from(candidates).some((script) => isCoreStripeJsUrl(script.src));
}

/** Stripe.js that the page loaded or is loading: a core Stripe.js tag, or `window.Stripe`. */
export function isPageStripeJsAvailable(): boolean {
  return isPageStripeJsTagPresent() || isStripeJsAvailable();
}

/** Resolves once the HTML document has finished parsing (at once if it already has). Never rejects. */
export function waitForParseEnd(): Promise<void> {
  if (typeof document === "undefined" || document.readyState !== "loading") {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", () => resolve(), { once: true });
  });
}
